import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "app/login/login.service";
import { FichasModel } from "./fichas.model";
import { FichasService } from "./fichas.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ClientesService } from "../clientes/clientes.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { ExportadoresService } from "../exportadores/exportadores.service";

declare let swal, $: any;

@Component({
  selector: 'app-fichas',
  templateUrl: './fichas.component.html'
})
export class FichasComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "id_importador": "", "id_exportador": "", "id_cliente": "", "container": "", "numero": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d" };
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  fichas: FichasModel[] = [];
  previstas: boolean = false;
  privilegioUsuario = { "editar": false, "consultar": false };
  permissoesMenu = [];

  podeFaturar = false;

  listStatusFichas = [];
  listMercadorias = [];
  listClientes = [];
  listExportadores = [];
  selecionarTodos: boolean = false;
  selecionados: any = {};
  processandoFicha: any = {};
  carregandoAcoesEmMassa: boolean = false;
  idFichaParaEnviarEmail: string;
  emailDestinatario: string = '';
  enviandoEmail: boolean = false;


  constructor(
    formBuilder: FormBuilder,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private exportadoresService: ExportadoresService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      let permissoes = [];
      for (let i in data.privilegios) {
        if (data.privilegios[i].consultar || data.privilegios[i].editar) {
          permissoes.push(String(data.privilegios[i].id_acao));
        }
        if (data.privilegios[i].acao && data.privilegios[i].acao[0] && data.privilegios[i].acao[0].url == 'fichas') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        } else if (data.privilegios[i].acao && data.privilegios[i].acao[0] && data.privilegios[i].acao[0].url == 'financeiro') {
          this.podeFaturar = data.privilegios[i].editar;
        }
      }
      this.permissoesMenu = permissoes;
    });

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      mercadoria: [],
      id_importador: [],
      id_exportador: [],
      id_cliente: [],
      container: [],
      numero: []
    });

    this.fichasService.getStatus()
      .subscribe(
        json => {
          this.listStatusFichas = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento'])
      .subscribe(
        json => {
          this.listClientes = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.exportadoresService.get()
      .subscribe(
        json => {
          this.listExportadores = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.mercadoriasService.get(null, null, ['id', 'nome_padrao'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    this.previstas = this.router.url.indexOf('/previstas') !== -1;

    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(ficha) {
    let fichas = this.fichas;
    let fichasService = this.fichasService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFicha') + ficha.id_ficha,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        if (self.global.debug == true) {
          console.log(fichas);
        }

        let index = fichas.indexOf(ficha);
        fichas.splice(index, 1);

        fichasService.apagar(ficha.id_ficha)
          .subscribe(res => {
            //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
            self.fichas = fichas;
          },
            err => {
              // Revert the view back to its original state
              fichas.splice(index, 0, ficha);
              self.fichas = fichas;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.status_pesquisa != '') {
      filtros['id_status'] = this.filtroPesquisa.status_pesquisa;
    } else {
      if (this.previstas) {
        filtros['id_status'] = 3;
      } else {
        filtros['id_status'] = 'ne:3';
      }
    }


    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_inspecao'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_inspecao'] = 'ge:' + this.filtroPesquisa.data_de;
      }

      if (this.filtroPesquisa.data_ate) {
        filtros['data_inspecao'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }


    if (this.filtroPesquisa.mercadoria != '') {
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    if (this.filtroPesquisa.id_importador != '') {
      filtros['id_importador'] = this.filtroPesquisa.id_importador;
    }

    if (this.filtroPesquisa.id_exportador != '') {
      filtros['id_exportador'] = this.filtroPesquisa.id_exportador;
    }

    if (this.filtroPesquisa.id_cliente != '') {
      filtros['id_cliente'] = this.filtroPesquisa.id_cliente;
    }

    if (this.filtroPesquisa.container != '') {
      filtros['container'] = "**:" + this.filtroPesquisa.container;
    }

    if (this.filtroPesquisa.numero != '') {
      filtros['numero'] = "**:" + this.filtroPesquisa.numero;
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data_inspecao';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.fichasService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria', 'importador', 'exportador', 'cliente', 'status'], filtros, null, sort)
      .subscribe(data => {
        this.fichas = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.fichas);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  gerarPDF(id) {
    alert('falta fazer');
  }

  enviaParaCliente(id) {

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaEnviarFichaCliente'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.processandoFicha[id] = true;
        self.fichasService.enviarFichaParaCliente(id)
          .subscribe(res => {
              delete self.processandoFicha[id];
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.notificadoComSucesso'), "success");
            },
            err => {
              delete self.processandoFicha[id];
              self.func.showErro(err.json());
            });

      });

  }


  alteraStatus(id_ficha, id_status, notifica = true) {

    let fichasService = this.fichasService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAlterarStatus'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true,
    },
      function () {
        self.processandoFicha[id_ficha] = true;
        fichasService.setStatus(id_ficha, id_status, notifica)
          .subscribe(res => {
            delete self.processandoFicha[id_ficha];
            swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");

            if (self.previstas) {
              self.router.navigate(['/painel', 'fichas', id_ficha, 'upd']);
            } else {
              self.getPage(self.paginaAtual);
            }
          },
            error => {
              delete self.processandoFicha[id_ficha];
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "id_importador": "", "id_exportador": "", "id_cliente": "", "container": "", "numero": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  // evento quando o container é alterado
  changeContainer(e) {
    this.filtroPesquisa.container = e.toUpperCase().replace(/_/g, '');
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.fichas.forEach(ficha => {
      this.selecionados[ficha.id_ficha] = this.selecionarTodos;
    });
  }

  marcarItem(ficha, event) {
    this.selecionados[ficha.id_ficha] = event.target.checked;

    // Se desmarcar um item, desmarca o "selecionar todos"
    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      // Verifica se todos foram marcados individualmente
      let todosMarcados = true;
      for (let f of this.fichas) {
        if (!this.selecionados[f.id_ficha]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

  executarAcaoEmMassa(acao: string, extraParam: any = null) {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaExecutarAcaoMassa'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    }, function () {
      self.carregandoAcoesEmMassa = true;
      let total = selecionadosIds.length;
      let concluidos = 0;

      selecionadosIds.forEach(id => {
        self.processandoFicha[id] = true;

        let obs;
        if (acao == 'deletar') obs = self.fichasService.apagar(id);
        if (acao == 'notificar') obs = self.fichasService.enviarFichaParaCliente(id);
        if (acao == 'status') obs = self.fichasService.setStatus(id, extraParam.id_status, extraParam.notifica);

        obs.subscribe(
          res => {
            delete self.processandoFicha[id];
            concluidos++;
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.acaoConcluida'), "success");
              self.getPage(self.paginaAtual);
              self.selecionados = {};
              self.selecionarTodos = false;
            }
          },
          err => {
            delete self.processandoFicha[id];
            concluidos++;
            self.func.showErro(err.json());
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              self.getPage(self.paginaAtual);
            }
          }
        );
      });
    });
  }

  abrirModalEnviarEmail(id) {
    this.idFichaParaEnviarEmail = id;
    this.emailDestinatario = '';
    this.enviandoEmail = false;
    $('#modalEnviarEmail').modal('show');
  }

  enviarEmail() {
    if (!this.emailDestinatario || !this.func.validaEmail(this.emailDestinatario)) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.emailInvalido'), "error");
      return;
    }

    this.enviandoEmail = true;
    this.fichasService.enviarFichaParaEmailEspecifico(this.idFichaParaEnviarEmail, this.emailDestinatario)
      .subscribe(
        res => {
          this.enviandoEmail = false;
          $('#modalEnviarEmail').modal('hide');
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.emailEnviadoSucesso'), "success");
        },
        err => {
          this.enviandoEmail = false;
          this.func.showErro(err.json());
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/fichas/fichas.component.ts